// Legendary Fitment — Bundle Data
// wheel x4 | tire x4 | center_cap x4 | lug_nut x (lug_count × 4)

const LF_BUNDLES = {
  "ford-f-150-gen-10-2004-2008": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-f-150-gen-11-2009-2014": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-f-150-gen-12-2015-2020": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-f-150-gen-13-2021-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-f-150-raptor-gen-1-svt-2010-2014": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-f-150-raptor-gen-2-2017-2020": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-f-150-raptor-gen-3-raptor-r-2021-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-ranger-2019-2025": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd798-addict-18x9-+18-matte-black-xd79889063718",
        "title": "Xd Xd798 Addict 18X9 +18 Matte Black",
        "brand": "Xd",
        "size": "18x9.0 18",
        "price": 165.0,
        "cap_part_no": "1079L140MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-matte-black-6x135-1079l140mb",
        "title": "Xds Cap Matte Black 6X135",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-glamis-17x9--12-matte-black-1790gla-26135m87",
        "title": "Black Rhino Hard Alloys Glamis 17X9 -12 Matte Black",
        "brand": "Black Rhino Hard Alloys",
        "size": "17x9.0 -12",
        "price": 159.0,
        "cap_part_no": "CCBR613540MBFLAT"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-cap-br-6-135-140-flat-matte-black-(m873)-ccbr613540mbflat",
        "title": "Cap Br 6/135/140 Flat Matte Black (M873)",
        "price": 21.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906301",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 234.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "moto-metal-mo977-link-20x9-+25-blackout-mo97729067325",
        "title": "Moto Metal Mo977 Link 20X9 +25 Blackout",
        "brand": "Moto Metal",
        "size": "20x9.0 25",
        "price": 247.0,
        "cap_part_no": "M-1016BO"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "moto-metal-mo977-black-out-cap-(sb-gb-sb-gb-sb)-m-1016bo",
        "title": "Mo977 Black Out Cap (Sb/Gb/Sb/Gb/Sb)",
        "price": 66.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-bronco-standard-2021-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-bronco-raptor-2022-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-super-duty-gen-1-1999-2007": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-delta-20x9.5--18-gloss-silver-w-mirror-face&lip-2095dlt-88170s25",
        "title": "Black Rhino Hard Alloys Delta 20X9.5 -18 Gloss Silver W Mirror Face&Lip",
        "brand": "Black Rhino Hard Alloys",
        "size": "20x9.5 -18",
        "price": 200.0,
        "cap_part_no": "CCBR48165180C"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd856-omega-20x10--18-satin-black-xd85621087718n",
        "title": "Xd Xd856 Omega 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "M-1052-S2"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-gb-bk)---20\"-only-m-1052-s2",
        "title": "Xds Cap Bolt-On (Sb/Gb/Bk) - 20\" Only",
        "price": 116.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422001747",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 338.0,
        "cap_part_no": "1001-63KACKIT5"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-blue-cap-w-1002-56kac-chr-logo-rivt-1001-63kackit5",
        "title": "Fuel Blue Cap W 1002-56Kac Chr Logo Rivt",
        "price": 47.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-fc889-blade-22x9-+20-matte-black-fc889mx22908720",
        "title": "Fuel 1Pc Fc889 Blade 22X9 +20 Matte Black",
        "brand": "Fuel 1Pc",
        "size": "22x9.0 20",
        "price": 485.0,
        "cap_part_no": "1008A63BLDKIT9"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb-mb)-8x170-tall-1008a63bldkit9",
        "title": "Fc Cap Bolt-On (Mb/Gb/Mb) 8X170 Tall",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278587500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "fuel-1pc-d742-runner-20x10--18-candy-red-milled-d74220001747",
        "title": "Fuel 1Pc D742 Runner 20X10 -18 Candy Red Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 249.0,
        "cap_part_no": "1004-08TGQC"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-8x6.5-170-gl-red-chr-logo-2.51\"-1004-08tgqc",
        "title": "Fuel Cap 8X6.5/170 Gl-Red/Chr Logo 2.51\"",
        "price": 41.0,
        "qty": 4
      }
    }
  },
  "ford-super-duty-gen-2-2008-2010": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-delta-20x9.5--18-gloss-silver-w-mirror-face&lip-2095dlt-88170s25",
        "title": "Black Rhino Hard Alloys Delta 20X9.5 -18 Gloss Silver W Mirror Face&Lip",
        "brand": "Black Rhino Hard Alloys",
        "size": "20x9.5 -18",
        "price": 200.0,
        "cap_part_no": "CCBR48165180C"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd856-omega-20x10--18-satin-black-xd85621087718n",
        "title": "Xd Xd856 Omega 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "M-1052-S2"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-gb-bk)---20\"-only-m-1052-s2",
        "title": "Xds Cap Bolt-On (Sb/Gb/Bk) - 20\" Only",
        "price": 116.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422001747",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 338.0,
        "cap_part_no": "1001-63KACKIT5"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-blue-cap-w-1002-56kac-chr-logo-rivt-1001-63kackit5",
        "title": "Fuel Blue Cap W 1002-56Kac Chr Logo Rivt",
        "price": 47.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-fc889-blade-22x9-+20-matte-black-fc889mx22908720",
        "title": "Fuel 1Pc Fc889 Blade 22X9 +20 Matte Black",
        "brand": "Fuel 1Pc",
        "size": "22x9.0 20",
        "price": 485.0,
        "cap_part_no": "1008A63BLDKIT9"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb-mb)-8x170-tall-1008a63bldkit9",
        "title": "Fc Cap Bolt-On (Mb/Gb/Mb) 8X170 Tall",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278587500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "fuel-1pc-d742-runner-20x10--18-candy-red-milled-d74220001747",
        "title": "Fuel 1Pc D742 Runner 20X10 -18 Candy Red Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 249.0,
        "cap_part_no": "1004-08TGQC"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-8x6.5-170-gl-red-chr-logo-2.51\"-1004-08tgqc",
        "title": "Fuel Cap 8X6.5/170 Gl-Red/Chr Logo 2.51\"",
        "price": 41.0,
        "qty": 4
      }
    }
  },
  "ford-super-duty-gen-3-2011-2016": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-delta-20x9.5--18-gloss-silver-w-mirror-face&lip-2095dlt-88170s25",
        "title": "Black Rhino Hard Alloys Delta 20X9.5 -18 Gloss Silver W Mirror Face&Lip",
        "brand": "Black Rhino Hard Alloys",
        "size": "20x9.5 -18",
        "price": 200.0,
        "cap_part_no": "CCBR48165180C"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd856-omega-20x10--18-satin-black-xd85621087718n",
        "title": "Xd Xd856 Omega 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "M-1052-S2"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-gb-bk)---20\"-only-m-1052-s2",
        "title": "Xds Cap Bolt-On (Sb/Gb/Bk) - 20\" Only",
        "price": 116.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422001747",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 338.0,
        "cap_part_no": "1001-63KACKIT5"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-blue-cap-w-1002-56kac-chr-logo-rivt-1001-63kackit5",
        "title": "Fuel Blue Cap W 1002-56Kac Chr Logo Rivt",
        "price": 47.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-fc889-blade-22x9-+20-matte-black-fc889mx22908720",
        "title": "Fuel 1Pc Fc889 Blade 22X9 +20 Matte Black",
        "brand": "Fuel 1Pc",
        "size": "22x9.0 20",
        "price": 485.0,
        "cap_part_no": "1008A63BLDKIT9"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb-mb)-8x170-tall-1008a63bldkit9",
        "title": "Fc Cap Bolt-On (Mb/Gb/Mb) 8X170 Tall",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278587500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "fuel-1pc-d742-runner-20x10--18-candy-red-milled-d74220001747",
        "title": "Fuel 1Pc D742 Runner 20X10 -18 Candy Red Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 249.0,
        "cap_part_no": "1004-08TGQC"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-8x6.5-170-gl-red-chr-logo-2.51\"-1004-08tgqc",
        "title": "Fuel Cap 8X6.5/170 Gl-Red/Chr Logo 2.51\"",
        "price": 41.0,
        "qty": 4
      }
    }
  },
  "ford-super-duty-gen-4-2017-2022": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-delta-20x9.5--18-gloss-silver-w-mirror-face&lip-2095dlt-88170s25",
        "title": "Black Rhino Hard Alloys Delta 20X9.5 -18 Gloss Silver W Mirror Face&Lip",
        "brand": "Black Rhino Hard Alloys",
        "size": "20x9.5 -18",
        "price": 200.0,
        "cap_part_no": "CCBR48165180C"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd856-omega-20x10--18-satin-black-xd85621087718n",
        "title": "Xd Xd856 Omega 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "M-1052-S2"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-gb-bk)---20\"-only-m-1052-s2",
        "title": "Xds Cap Bolt-On (Sb/Gb/Bk) - 20\" Only",
        "price": 116.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422001747",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 338.0,
        "cap_part_no": "1001-63KACKIT5"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-blue-cap-w-1002-56kac-chr-logo-rivt-1001-63kackit5",
        "title": "Fuel Blue Cap W 1002-56Kac Chr Logo Rivt",
        "price": 47.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-fc889-blade-22x9-+20-matte-black-fc889mx22908720",
        "title": "Fuel 1Pc Fc889 Blade 22X9 +20 Matte Black",
        "brand": "Fuel 1Pc",
        "size": "22x9.0 20",
        "price": 485.0,
        "cap_part_no": "1008A63BLDKIT9"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb-mb)-8x170-tall-1008a63bldkit9",
        "title": "Fc Cap Bolt-On (Mb/Gb/Mb) 8X170 Tall",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278587500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "fuel-1pc-d742-runner-20x10--18-candy-red-milled-d74220001747",
        "title": "Fuel 1Pc D742 Runner 20X10 -18 Candy Red Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 249.0,
        "cap_part_no": "1004-08TGQC"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-8x6.5-170-gl-red-chr-logo-2.51\"-1004-08tgqc",
        "title": "Fuel Cap 8X6.5/170 Gl-Red/Chr Logo 2.51\"",
        "price": 41.0,
        "qty": 4
      }
    }
  },
  "ford-super-duty-gen-5-2023-2025": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-delta-20x9.5--18-gloss-silver-w-mirror-face&lip-2095dlt-88170s25",
        "title": "Black Rhino Hard Alloys Delta 20X9.5 -18 Gloss Silver W Mirror Face&Lip",
        "brand": "Black Rhino Hard Alloys",
        "size": "20x9.5 -18",
        "price": 200.0,
        "cap_part_no": "CCBR48165180C"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd856-omega-20x10--18-satin-black-xd85621087718n",
        "title": "Xd Xd856 Omega 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "M-1052-S2"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-gb-bk)---20\"-only-m-1052-s2",
        "title": "Xds Cap Bolt-On (Sb/Gb/Bk) - 20\" Only",
        "price": 116.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422001747",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 338.0,
        "cap_part_no": "1001-63KACKIT5"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-blue-cap-w-1002-56kac-chr-logo-rivt-1001-63kackit5",
        "title": "Fuel Blue Cap W 1002-56Kac Chr Logo Rivt",
        "price": 47.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-fc889-blade-22x9-+20-matte-black-fc889mx22908720",
        "title": "Fuel 1Pc Fc889 Blade 22X9 +20 Matte Black",
        "brand": "Fuel 1Pc",
        "size": "22x9.0 20",
        "price": 485.0,
        "cap_part_no": "1008A63BLDKIT9"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb-mb)-8x170-tall-1008a63bldkit9",
        "title": "Fc Cap Bolt-On (Mb/Gb/Mb) 8X170 Tall",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278587500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "fuel-1pc-d742-runner-20x10--18-candy-red-milled-d74220001747",
        "title": "Fuel 1Pc D742 Runner 20X10 -18 Candy Red Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 249.0,
        "cap_part_no": "1004-08TGQC"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-8x6.5-170-gl-red-chr-logo-2.51\"-1004-08tgqc",
        "title": "Fuel Cap 8X6.5/170 Gl-Red/Chr Logo 2.51\"",
        "price": 41.0,
        "qty": 4
      }
    }
  },
  "ford-expedition-2003-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ford-explorer-gen-5-2011-2019": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-wwp2-20x9-+35-satin-black-ar948mx20905435",
        "title": "American Racing Wwp2 20X9 +35 Satin Black",
        "brand": "American Racing",
        "size": "20x9.0 35",
        "price": 258.0,
        "cap_part_no": "AR948CAP-S1"
      },
      "tire": {
        "handle": "nitto-motivo-255-35zr20-n210-430",
        "title": "Nitto Motivo 255/35ZR20",
        "size": "255/35ZR20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "american-racing-wwp-ar-cap-snap-in-(sb-gb)-ar948cap-s1",
        "title": "Wwp Ar Cap Snap In (Sb/Gb)",
        "price": 18.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d556-coupler-20x9-+1-matte-black-double-dark-tint-d55620902650",
        "title": "Fuel 1Pc D556 Coupler 20X9 +1 Matte Black Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 251.0,
        "cap_part_no": "1001-63-B"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-black-cap-bk-04-1001-63-b",
        "title": "Fuel Black Cap Bk-04",
        "price": 29.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "asanti-black-abl-23-sigma-22x9-+32-brushed-silver-w--chrome-lip-abl23-22901232sl",
        "title": "Asanti Black Abl-23 Sigma 22X9 +32 Brushed Silver W/ Chrome Lip",
        "brand": "Asanti Black",
        "size": "22x9.0 32",
        "price": 641.0,
        "cap_part_no": "ABLCAP-CH1"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "asanti-black-abl-cap-snap-in-(ch1-gb)---all-pcd-ablcap-ch1",
        "title": "Abl Cap Snap-In (Ch1/Gb) - All Pcd",
        "price": 9.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-mammoth-22x9.5-+30-matte-anthracite-st002ax22951230",
        "title": "Status Mammoth 22X9.5 +30 Matte Anthracite",
        "brand": "Status",
        "size": "22x9.5 30",
        "price": 252.0,
        "cap_part_no": "1006-52VLB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "status-status-snap-in-cap-72.56-cb-(anth-g-blk)-1006-52vlb",
        "title": "Status Snap In Cap 72.56 Cb (Anth/G-Blk)",
        "price": 13.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278512500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "ford-explorer-gen-6-2020-2025": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-wwp2-20x9-+35-satin-black-ar948mx20905435",
        "title": "American Racing Wwp2 20X9 +35 Satin Black",
        "brand": "American Racing",
        "size": "20x9.0 35",
        "price": 258.0,
        "cap_part_no": "AR948CAP-S1"
      },
      "tire": {
        "handle": "nitto-motivo-255-35zr20-n210-430",
        "title": "Nitto Motivo 255/35ZR20",
        "size": "255/35ZR20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "american-racing-wwp-ar-cap-snap-in-(sb-gb)-ar948cap-s1",
        "title": "Wwp Ar Cap Snap In (Sb/Gb)",
        "price": 18.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d556-coupler-20x9-+1-matte-black-double-dark-tint-d55620902650",
        "title": "Fuel 1Pc D556 Coupler 20X9 +1 Matte Black Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 251.0,
        "cap_part_no": "1001-63-B"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-black-cap-bk-04-1001-63-b",
        "title": "Fuel Black Cap Bk-04",
        "price": 29.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "asanti-black-abl-23-sigma-22x9-+32-brushed-silver-w--chrome-lip-abl23-22901232sl",
        "title": "Asanti Black Abl-23 Sigma 22X9 +32 Brushed Silver W/ Chrome Lip",
        "brand": "Asanti Black",
        "size": "22x9.0 32",
        "price": 641.0,
        "cap_part_no": "ABLCAP-CH1"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "asanti-black-abl-cap-snap-in-(ch1-gb)---all-pcd-ablcap-ch1",
        "title": "Abl Cap Snap-In (Ch1/Gb) - All Pcd",
        "price": 9.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-mammoth-22x9.5-+30-matte-anthracite-st002ax22951230",
        "title": "Status Mammoth 22X9.5 +30 Matte Anthracite",
        "brand": "Status",
        "size": "22x9.5 30",
        "price": 252.0,
        "cap_part_no": "1006-52VLB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "status-status-snap-in-cap-72.56-cb-(anth-g-blk)-1006-52vlb",
        "title": "Status Snap In Cap 72.56 Cb (Anth/G-Blk)",
        "price": 13.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278512500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "chevy-silverado-1500-gen-1-1999-2007": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "chevy-silverado-1500-gen-2-2007-2013": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "chevy-silverado-1500-gen-3-2014-2018": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "chevy-silverado-1500-gen-4-2019-2025": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "chevy-silverado-2500hd-gen-1-2001-2010": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "chevy-silverado-2500hd-gen-2-2011-2019": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "chevy-silverado-2500hd-gen-3-2020-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "chevy-colorado-gen-1-2004-2012": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d768-rush-18x9-+20-matte-bronze-d76818909457",
        "title": "Fuel 1Pc D768 Rush 18X9 +20 Matte Bronze",
        "brand": "Fuel 1Pc",
        "size": "18x9.0 20",
        "price": 212.0,
        "cap_part_no": "1006-41MBZ"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x4.5-5.5-mb-brz-logo-1006-41mbz",
        "title": "Fuel Cap 6X4.5/5.5 Mb/Brz Logo",
        "price": 35.75,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d847-rebar-17x9-+1-blackout-d84717909450",
        "title": "Fuel 1Pc D847 Rebar 17X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 1",
        "price": 320.0,
        "cap_part_no": "1004-68GBLD"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-snap-in-(mb-gb)---5x5.0-1004-68gbld",
        "title": "Fuel Cap Snap In (Mb/Gb) - 5X5.0",
        "price": 40.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d609-triton-20x9-+20-chrome-plated-d60920906957",
        "title": "Fuel 1Pc D609 Triton 20X9 +20 Chrome Plated",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 20",
        "price": 585.0,
        "cap_part_no": "1001-81"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-5-6-lug-chrome-cap-(flat-bottom)-1001-81",
        "title": "Fuel 5/6 Lug Chrome Cap (Flat Bottom)",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208594+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "kmc-km237-riot-beadlock-17x8.5-+0-machined-km237dx17857700",
        "title": "Kmc Km237 Riot Beadlock 17X8.5 +0 Machined",
        "brand": "Kmc",
        "size": "17x8.5 0",
        "price": 695.0,
        "cap_part_no": "T163H140-6-H30-P1"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "kmc-kmc-cap-bolt-on-(po-gb-ch)---6x135-t163h140-6-h30-p1",
        "title": "Kmc Cap Bolt-On (Po/Gb/Ch) - 6X135",
        "price": 63.0,
        "qty": 4
      }
    }
  },
  "chevy-colorado-gen-2-2015-2022": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d768-rush-18x9-+20-matte-bronze-d76818909457",
        "title": "Fuel 1Pc D768 Rush 18X9 +20 Matte Bronze",
        "brand": "Fuel 1Pc",
        "size": "18x9.0 20",
        "price": 212.0,
        "cap_part_no": "1006-41MBZ"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x4.5-5.5-mb-brz-logo-1006-41mbz",
        "title": "Fuel Cap 6X4.5/5.5 Mb/Brz Logo",
        "price": 35.75,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d847-rebar-17x9-+1-blackout-d84717909450",
        "title": "Fuel 1Pc D847 Rebar 17X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 1",
        "price": 320.0,
        "cap_part_no": "1004-68GBLD"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-snap-in-(mb-gb)---5x5.0-1004-68gbld",
        "title": "Fuel Cap Snap In (Mb/Gb) - 5X5.0",
        "price": 40.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d609-triton-20x9-+20-chrome-plated-d60920906957",
        "title": "Fuel 1Pc D609 Triton 20X9 +20 Chrome Plated",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 20",
        "price": 585.0,
        "cap_part_no": "1001-81"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-5-6-lug-chrome-cap-(flat-bottom)-1001-81",
        "title": "Fuel 5/6 Lug Chrome Cap (Flat Bottom)",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208594+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "kmc-km237-riot-beadlock-17x8.5-+0-machined-km237dx17857700",
        "title": "Kmc Km237 Riot Beadlock 17X8.5 +0 Machined",
        "brand": "Kmc",
        "size": "17x8.5 0",
        "price": 695.0,
        "cap_part_no": "T163H140-6-H30-P1"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "kmc-kmc-cap-bolt-on-(po-gb-ch)---6x135-t163h140-6-h30-p1",
        "title": "Kmc Cap Bolt-On (Po/Gb/Ch) - 6X135",
        "price": 63.0,
        "qty": 4
      }
    }
  },
  "chevy-colorado-gen-3-2023-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d768-rush-18x9-+20-matte-bronze-d76818909457",
        "title": "Fuel 1Pc D768 Rush 18X9 +20 Matte Bronze",
        "brand": "Fuel 1Pc",
        "size": "18x9.0 20",
        "price": 212.0,
        "cap_part_no": "1006-41MBZ"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x4.5-5.5-mb-brz-logo-1006-41mbz",
        "title": "Fuel Cap 6X4.5/5.5 Mb/Brz Logo",
        "price": 35.75,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d847-rebar-17x9-+1-blackout-d84717909450",
        "title": "Fuel 1Pc D847 Rebar 17X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 1",
        "price": 320.0,
        "cap_part_no": "1004-68GBLD"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-snap-in-(mb-gb)---5x5.0-1004-68gbld",
        "title": "Fuel Cap Snap In (Mb/Gb) - 5X5.0",
        "price": 40.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d609-triton-20x9-+20-chrome-plated-d60920906957",
        "title": "Fuel 1Pc D609 Triton 20X9 +20 Chrome Plated",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 20",
        "price": 585.0,
        "cap_part_no": "1001-81"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-5-6-lug-chrome-cap-(flat-bottom)-1001-81",
        "title": "Fuel 5/6 Lug Chrome Cap (Flat Bottom)",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208594+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "kmc-km237-riot-beadlock-17x8.5-+0-machined-km237dx17857700",
        "title": "Kmc Km237 Riot Beadlock 17X8.5 +0 Machined",
        "brand": "Kmc",
        "size": "17x8.5 0",
        "price": 695.0,
        "cap_part_no": "T163H140-6-H30-P1"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "kmc-kmc-cap-bolt-on-(po-gb-ch)---6x135-t163h140-6-h30-p1",
        "title": "Kmc Cap Bolt-On (Po/Gb/Ch) - 6X135",
        "price": 63.0,
        "qty": 4
      }
    }
  },
  "chevy-tahoe-gen-4-2015-2020": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "chevy-tahoe-gen-5-2021-2025": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "chevy-suburban-gen-4-2015-2020": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "chevy-suburban-gen-5-2021-2025": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-1500-gen-1-1999-2007": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-1500-gen-2-2007-2013": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-1500-gen-2-2007-2014": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-1500-gen-3-2014-2018": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-1500-gen-4-2019-2025": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-2500hd-gen-1-2001-2010": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-2500hd-gen-2-2011-2019": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "gmc-sierra-2500hd-gen-3-2020-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "gmc-canyon-gen-1-2004-2012": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d768-rush-18x9-+20-matte-bronze-d76818909457",
        "title": "Fuel 1Pc D768 Rush 18X9 +20 Matte Bronze",
        "brand": "Fuel 1Pc",
        "size": "18x9.0 20",
        "price": 212.0,
        "cap_part_no": "1006-41MBZ"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x4.5-5.5-mb-brz-logo-1006-41mbz",
        "title": "Fuel Cap 6X4.5/5.5 Mb/Brz Logo",
        "price": 35.75,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d847-rebar-17x9-+1-blackout-d84717909450",
        "title": "Fuel 1Pc D847 Rebar 17X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 1",
        "price": 320.0,
        "cap_part_no": "1004-68GBLD"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-snap-in-(mb-gb)---5x5.0-1004-68gbld",
        "title": "Fuel Cap Snap In (Mb/Gb) - 5X5.0",
        "price": 40.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d609-triton-20x9-+20-chrome-plated-d60920906957",
        "title": "Fuel 1Pc D609 Triton 20X9 +20 Chrome Plated",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 20",
        "price": 585.0,
        "cap_part_no": "1001-81"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-5-6-lug-chrome-cap-(flat-bottom)-1001-81",
        "title": "Fuel 5/6 Lug Chrome Cap (Flat Bottom)",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208594+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "kmc-km237-riot-beadlock-17x8.5-+0-machined-km237dx17857700",
        "title": "Kmc Km237 Riot Beadlock 17X8.5 +0 Machined",
        "brand": "Kmc",
        "size": "17x8.5 0",
        "price": 695.0,
        "cap_part_no": "T163H140-6-H30-P1"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "kmc-kmc-cap-bolt-on-(po-gb-ch)---6x135-t163h140-6-h30-p1",
        "title": "Kmc Cap Bolt-On (Po/Gb/Ch) - 6X135",
        "price": 63.0,
        "qty": 4
      }
    }
  },
  "gmc-canyon-gen-2-2015-2022": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d768-rush-18x9-+20-matte-bronze-d76818909457",
        "title": "Fuel 1Pc D768 Rush 18X9 +20 Matte Bronze",
        "brand": "Fuel 1Pc",
        "size": "18x9.0 20",
        "price": 212.0,
        "cap_part_no": "1006-41MBZ"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x4.5-5.5-mb-brz-logo-1006-41mbz",
        "title": "Fuel Cap 6X4.5/5.5 Mb/Brz Logo",
        "price": 35.75,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d847-rebar-17x9-+1-blackout-d84717909450",
        "title": "Fuel 1Pc D847 Rebar 17X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 1",
        "price": 320.0,
        "cap_part_no": "1004-68GBLD"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-snap-in-(mb-gb)---5x5.0-1004-68gbld",
        "title": "Fuel Cap Snap In (Mb/Gb) - 5X5.0",
        "price": 40.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d609-triton-20x9-+20-chrome-plated-d60920906957",
        "title": "Fuel 1Pc D609 Triton 20X9 +20 Chrome Plated",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 20",
        "price": 585.0,
        "cap_part_no": "1001-81"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-5-6-lug-chrome-cap-(flat-bottom)-1001-81",
        "title": "Fuel 5/6 Lug Chrome Cap (Flat Bottom)",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208594+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "kmc-km237-riot-beadlock-17x8.5-+0-machined-km237dx17857700",
        "title": "Kmc Km237 Riot Beadlock 17X8.5 +0 Machined",
        "brand": "Kmc",
        "size": "17x8.5 0",
        "price": 695.0,
        "cap_part_no": "T163H140-6-H30-P1"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "kmc-kmc-cap-bolt-on-(po-gb-ch)---6x135-t163h140-6-h30-p1",
        "title": "Kmc Cap Bolt-On (Po/Gb/Ch) - 6X135",
        "price": 63.0,
        "qty": 4
      }
    }
  },
  "gmc-canyon-gen-3-2023-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d768-rush-18x9-+20-matte-bronze-d76818909457",
        "title": "Fuel 1Pc D768 Rush 18X9 +20 Matte Bronze",
        "brand": "Fuel 1Pc",
        "size": "18x9.0 20",
        "price": 212.0,
        "cap_part_no": "1006-41MBZ"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x4.5-5.5-mb-brz-logo-1006-41mbz",
        "title": "Fuel Cap 6X4.5/5.5 Mb/Brz Logo",
        "price": 35.75,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d847-rebar-17x9-+1-blackout-d84717909450",
        "title": "Fuel 1Pc D847 Rebar 17X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 1",
        "price": 320.0,
        "cap_part_no": "1004-68GBLD"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-snap-in-(mb-gb)---5x5.0-1004-68gbld",
        "title": "Fuel Cap Snap In (Mb/Gb) - 5X5.0",
        "price": 40.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d609-triton-20x9-+20-chrome-plated-d60920906957",
        "title": "Fuel 1Pc D609 Triton 20X9 +20 Chrome Plated",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 20",
        "price": 585.0,
        "cap_part_no": "1001-81"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-5-6-lug-chrome-cap-(flat-bottom)-1001-81",
        "title": "Fuel 5/6 Lug Chrome Cap (Flat Bottom)",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208594+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "kmc-km237-riot-beadlock-17x8.5-+0-machined-km237dx17857700",
        "title": "Kmc Km237 Riot Beadlock 17X8.5 +0 Machined",
        "brand": "Kmc",
        "size": "17x8.5 0",
        "price": 695.0,
        "cap_part_no": "T163H140-6-H30-P1"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "kmc-kmc-cap-bolt-on-(po-gb-ch)---6x135-t163h140-6-h30-p1",
        "title": "Kmc Cap Bolt-On (Po/Gb/Ch) - 6X135",
        "price": 63.0,
        "qty": 4
      }
    }
  },
  "gmc-yukon-gen-4-2015-2020": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "gmc-yukon-gen-5-2021-2025": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ram-1500-gen-3-2002-2008": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd829-hoss-ii-20x9-+0-gloss-black-xd82929085300",
        "title": "Xd Xd829 Hoss Ii 20X9 +0 Gloss Black",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 230.0,
        "cap_part_no": "1079L145AGB1-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-gloss-black-5x5.5-150-(new-logo)-1079l145agb1-h42",
        "title": "Xds Cap Gloss Black 5X5.5/150 (New Logo)",
        "price": 21.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa73-trilogy-20x10--18-satin-black-milled-pxa5173-21085",
        "title": "Pro Comp Alloys Pa73 Trilogy 20X10 -18 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "20x10.0 -18",
        "price": 180.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 20
      },
      "center_cap": null
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-2pc-d240-cleaver-22x10--13-chrome-plated-gloss-black-lip-d24022007050",
        "title": "Fuel 2Pc D240 Cleaver 22X10 -13 Chrome Plated Gloss Black Lip",
        "brand": "Fuel 2Pc",
        "size": "22x10.0 -13",
        "price": 635.0,
        "cap_part_no": "1001-63"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-chrome-covered-cap-1001-63",
        "title": "Fuel Chrome Covered Cap",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-kruger-22x9.5-+20-gloss-black-2295krg205140b78",
        "title": "Black Rhino Hard Alloys Kruger 22X9.5 +20 Gloss Black",
        "brand": "Black Rhino Hard Alloys",
        "size": "22x9.5 20",
        "price": 434.0,
        "cap_part_no": "CCBR75S"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 20
      },
      "center_cap": null
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd2227855550r2",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "ram-1500-gen-4-2009-2018": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd829-hoss-ii-20x9-+0-gloss-black-xd82929085300",
        "title": "Xd Xd829 Hoss Ii 20X9 +0 Gloss Black",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 230.0,
        "cap_part_no": "1079L145AGB1-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-gloss-black-5x5.5-150-(new-logo)-1079l145agb1-h42",
        "title": "Xds Cap Gloss Black 5X5.5/150 (New Logo)",
        "price": 21.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa73-trilogy-20x10--18-satin-black-milled-pxa5173-21085",
        "title": "Pro Comp Alloys Pa73 Trilogy 20X10 -18 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "20x10.0 -18",
        "price": 180.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-2pc-d240-cleaver-22x10--13-chrome-plated-gloss-black-lip-d24022007050",
        "title": "Fuel 2Pc D240 Cleaver 22X10 -13 Chrome Plated Gloss Black Lip",
        "brand": "Fuel 2Pc",
        "size": "22x10.0 -13",
        "price": 635.0,
        "cap_part_no": "1001-63"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-chrome-covered-cap-1001-63",
        "title": "Fuel Chrome Covered Cap",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-kruger-22x9.5-+20-gloss-black-2295krg205140b78",
        "title": "Black Rhino Hard Alloys Kruger 22X9.5 +20 Gloss Black",
        "brand": "Black Rhino Hard Alloys",
        "size": "22x9.5 20",
        "price": 434.0,
        "cap_part_no": "CCBR75S"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd2227855550r2",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "ram-1500-gen-5-2019-2025": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd829-hoss-ii-20x9-+0-gloss-black-xd82929085300",
        "title": "Xd Xd829 Hoss Ii 20X9 +0 Gloss Black",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 230.0,
        "cap_part_no": "1079L145AGB1-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-gloss-black-5x5.5-150-(new-logo)-1079l145agb1-h42",
        "title": "Xds Cap Gloss Black 5X5.5/150 (New Logo)",
        "price": 21.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa73-trilogy-20x10--18-satin-black-milled-pxa5173-21085",
        "title": "Pro Comp Alloys Pa73 Trilogy 20X10 -18 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "20x10.0 -18",
        "price": 180.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-2pc-d240-cleaver-22x10--13-chrome-plated-gloss-black-lip-d24022007050",
        "title": "Fuel 2Pc D240 Cleaver 22X10 -13 Chrome Plated Gloss Black Lip",
        "brand": "Fuel 2Pc",
        "size": "22x10.0 -13",
        "price": 635.0,
        "cap_part_no": "1001-63"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-chrome-covered-cap-1001-63",
        "title": "Fuel Chrome Covered Cap",
        "price": 40.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-kruger-22x9.5-+20-gloss-black-2295krg205140b78",
        "title": "Black Rhino Hard Alloys Kruger 22X9.5 +20 Gloss Black",
        "brand": "Black Rhino Hard Alloys",
        "size": "22x9.5 20",
        "price": 434.0,
        "cap_part_no": "CCBR75S"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd2227855550r2",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 323.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "ram-trx-2021-2024": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d720-heater-20x9-+1-matte-black-ddt-machined-d72020908950",
        "title": "Fuel 1Pc D720 Heater 20X9 +1 Matte Black Ddt Machined",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 221.0,
        "cap_part_no": "1005-69MB"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-m-blk-cap-m-blk-screw---6x135-1005-69mb",
        "title": "Fuel M-Blk Cap M-Blk Screw - 6X135",
        "price": 22.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd846-double-deuce-20x10--18-satin-black-xd84621063718n",
        "title": "Xd Xd846 Double Deuce 20X10 -18 Satin Black",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 142.0,
        "cap_part_no": "1636S04"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xds-cap-bolt-on-(sb-ch-bk)---6x135-1636s04",
        "title": "Xds Cap Bolt-On (Sb/Ch/Bk) - 6X135",
        "price": 18.6,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-22x10--18-blackout-fc862mx22106318n",
        "title": "Fuel 1Pc Fc862 Scepter 22X10 -18 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 297.0,
        "cap_part_no": "1004-37BLD"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x135-5.5-1004-37bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "status-st005-matrix-22x9.5-+25-matte-black-st005mx22956625",
        "title": "Status St005 Matrix 22X9.5 +25 Matte Black",
        "brand": "Status",
        "size": "22x9.5 25",
        "price": 293.0,
        "cap_part_no": "STCAP100MBPA272CX"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "status-st-cap-snap-in-(mb-gb-gb-ch)-od-101-stcap100mbpa272cx",
        "title": "St Cap Snap-In (Mb/Gb/Gb/Ch) Od 101",
        "price": 51.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908945",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 298.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "ram-2500-gen-3-2003-2009": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "ram-2500-gen-4-2010-2018": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "ram-2500-gen-5-2019-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "ram-3500-gen-3-2003-2009": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "misc-accessories-9-16\"-acorn-bulge-lug-1.75\"-1910l",
        "title": "9/16\" Acorn Bulge Lug 1.75\"",
        "price": 1.21,
        "thread_pitch": "9/16x18",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "ram-3500-gen-4-2010-2018": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "ram-3500-gen-5-2019-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d770-twitch-20x10--18-anodized-blue-milled-d77020008247",
        "title": "Fuel 1Pc D770 Twitch 20X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 245.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd860-onslaught-20x10--18-gloss-black-milled-xd86021080318n",
        "title": "Xd Xd860 Onslaught 20X10 -18 Gloss Black Milled",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 266.0,
        "cap_part_no": "T167L1708S1-H50"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "xd-xds-boltoncap-gb-ch-bk-revstar-8x6.5-180-t167l1708s1-h50",
        "title": "Xds Boltoncap Gb/Ch/Bk Revstar-8X6.5/180",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d774-typhoon-22x10--18-anodized-blue-milled-d77422008247",
        "title": "Fuel 1Pc D774 Typhoon 22X10 -18 Anodized Blue Milled",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -18",
        "price": 328.0,
        "cap_part_no": "1002-53KAC"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-8lug-blue-cap-w-riser-ch-logo-rivet-1002-53kac",
        "title": "Fuel 8Lug Blue Cap W Riser-Ch Logo Rivet",
        "price": 45.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr207-22x8.5-+15-gloss-black-207gb-22858115",
        "title": "Performance Replicas Pr207 22X8.5 +15 Gloss Black",
        "brand": "Performance Replicas",
        "size": "22x8.5 15",
        "price": 384.0,
        "cap_part_no": "207GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "performance-replicas-pr207-gloss-black-cap-207gb",
        "title": "Pr207 Gloss Black Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278580500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 288.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": null
    },
    "Duallys": {
      "wheel": {
        "handle": "moto-metal-mo995-20x8.25-+127-satin-black-milled-mo995208807127",
        "title": "Moto Metal Mo995 20X8.25 +127 Satin Black Milled",
        "brand": "Moto Metal",
        "size": "20x8.25 127",
        "price": 142.0,
        "cap_part_no": "1079L171FMOSB-H44"
      },
      "tire": {
        "handle": "milestar-patagonia-h-t-275-55r20-m24660007",
        "title": "Milestar Patagonia H/T 275/55R20",
        "size": "275/55R20",
        "price": 169.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 32
      },
      "center_cap": {
        "handle": "moto-metal-moto-dually-front-cap-(sb-ch)---8x6.5-1079l171fmosb-h44",
        "title": "Moto Dually Front Cap (Sb/Ch) - 8X6.5",
        "price": 28.0,
        "qty": 4
      }
    }
  },
  "toyota-tundra-gen-1-2000-2006": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd820-grenade-20x9-+0-satin-black-milled-xd82029058900us",
        "title": "Xd Xd820 Grenade 20X9 +0 Satin Black Milled",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 308.0,
        "cap_part_no": "1079L145ASB-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-5x5.5-150---satin-black-1079l145asb-h42",
        "title": "Xds Cap 5X5.5/150 - Satin Black",
        "price": 26.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d749-hammer-20x10--18-gloss-black-milled-d74920005647",
        "title": "Fuel 1Pc D749 Hammer 20X10 -18 Gloss Black Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 457.0,
        "cap_part_no": "1006-15GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-5x150-gb-chr-logo-1006-15gb",
        "title": "Fuel Cap 5X150 Gb Chr Logo",
        "price": 27.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-ff110-22x10--25-polished-ffgff110rt10-1-34",
        "title": "Fuel 1Pc Ff110 22X10 -25 Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -25",
        "price": 720.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d864-hurricane-22x12--44-blackout-d86422205647",
        "title": "Fuel 1Pc D864 Hurricane 22X12 -44 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x12.0 -44",
        "price": 560.0,
        "cap_part_no": "1004-42BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x150-1004-42bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X150",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278558500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "toyota-tundra-gen-2-2007-2021": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd820-grenade-20x9-+0-satin-black-milled-xd82029058900us",
        "title": "Xd Xd820 Grenade 20X9 +0 Satin Black Milled",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 308.0,
        "cap_part_no": "1079L145ASB-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-5x5.5-150---satin-black-1079l145asb-h42",
        "title": "Xds Cap 5X5.5/150 - Satin Black",
        "price": 26.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d749-hammer-20x10--18-gloss-black-milled-d74920005647",
        "title": "Fuel 1Pc D749 Hammer 20X10 -18 Gloss Black Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 457.0,
        "cap_part_no": "1006-15GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-5x150-gb-chr-logo-1006-15gb",
        "title": "Fuel Cap 5X150 Gb Chr Logo",
        "price": 27.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-ff110-22x10--25-polished-ffgff110rt10-1-34",
        "title": "Fuel 1Pc Ff110 22X10 -25 Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -25",
        "price": 720.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d864-hurricane-22x12--44-blackout-d86422205647",
        "title": "Fuel 1Pc D864 Hurricane 22X12 -44 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x12.0 -44",
        "price": 560.0,
        "cap_part_no": "1004-42BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x150-1004-42bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X150",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278558500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "toyota-tundra-gen-3-2022-2025": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn506-rally-20x9.5-+0-mag-gray-center-w--polished-lp-vn50629561400",
        "title": "American Racing Vintage Vn506 Rally 20X9.5 +0 Mag Gray Center W/ Polished Lp",
        "brand": "American Racing Vintage",
        "size": "20x9.5 0",
        "price": 241.0,
        "cap_part_no": "711012AAR"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn327-vn506-2pc-cap---chrome-711012aar",
        "title": "Vn327/Vn506 2Pc Cap - Chrome",
        "price": 241.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "xd-xd862-raid-20x10--18-cement-xd86221068418n",
        "title": "Xd Xd862 Raid 20X10 -18 Cement",
        "brand": "Xd",
        "size": "20x10.0 -18",
        "price": 230.0,
        "cap_part_no": "T167L1456S7-H42"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "xd-xd-bolton-cap-(sb-gb-bk)-revstar--6x5.5-t167l1456s7-h42",
        "title": "Xd Bolton Cap (Sb/Gb/Bk) Revstar- 6X5.5",
        "price": 35.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-d721-ignite-22x10--19-high-luster-polished-d72122008447",
        "title": "Fuel 1Pc D721 Ignite 22X10 -19 High Luster Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -19",
        "price": 351.0,
        "cap_part_no": "1004-27"
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(ch-gb)---6x5.5-1004-27",
        "title": "Fc Cap Bolt-On (Ch/Gb) - 6X5.5",
        "price": 39.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "helo-he835-22x9.5-+18-gloss-black-machined-he83522968318",
        "title": "Helo He835 22X9.5 +18 Gloss Black Machined",
        "brand": "Helo",
        "size": "22x9.5 18",
        "price": 249.0,
        "cap_part_no": "835B6139"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "helo-hlo-cap-he835-chrome-w-spacer-6x135-5.5-835b6139",
        "title": "Hlo Cap He835 Chrome W/Spacer 6X135/5.5",
        "price": 31.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-tacoma-gen-1-1995-2004": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-rapid-18x9-+12-midnight-blue-1890rpd126140u12",
        "title": "Black Rhino Hard Alloys Rapid 18X9 +12 Midnight Blue",
        "brand": "Black Rhino Hard Alloys",
        "size": "18x9.0 12",
        "price": 128.0,
        "cap_part_no": "CCBR66135140MM"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-br-cap-anim-bolt-on-(mb-mb-mb)-6x135-5.5-ccbr66135140mm",
        "title": "Br Cap Anim Bolt-On (Mb/Mb/Mb)-6X135/5.5",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa40-vertigo-17x9--6-satin-black-milled-pxa5140-7983",
        "title": "Pro Comp Alloys Pa40 Vertigo 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 167.0,
        "cap_part_no": "PXA504055602"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "pro-comp-alloys-pxa-snap-in-cap-s-blk-pxa504055602",
        "title": "Pxa Snap-In Cap S-Blk",
        "price": 26.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906801",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 435.0,
        "cap_part_no": "1004-27BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x5.5-1004-27bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X5.5",
        "price": 34.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208583+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-tacoma-gen-2-2005-2015": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-rapid-18x9-+12-midnight-blue-1890rpd126140u12",
        "title": "Black Rhino Hard Alloys Rapid 18X9 +12 Midnight Blue",
        "brand": "Black Rhino Hard Alloys",
        "size": "18x9.0 12",
        "price": 128.0,
        "cap_part_no": "CCBR66135140MM"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-br-cap-anim-bolt-on-(mb-mb-mb)-6x135-5.5-ccbr66135140mm",
        "title": "Br Cap Anim Bolt-On (Mb/Mb/Mb)-6X135/5.5",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa40-vertigo-17x9--6-satin-black-milled-pxa5140-7983",
        "title": "Pro Comp Alloys Pa40 Vertigo 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 167.0,
        "cap_part_no": "PXA504055602"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "pro-comp-alloys-pxa-snap-in-cap-s-blk-pxa504055602",
        "title": "Pxa Snap-In Cap S-Blk",
        "price": 26.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906801",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 435.0,
        "cap_part_no": "1004-27BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x5.5-1004-27bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X5.5",
        "price": 34.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208583+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-tacoma-gen-3-2016-2023": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-rapid-18x9-+12-midnight-blue-1890rpd126140u12",
        "title": "Black Rhino Hard Alloys Rapid 18X9 +12 Midnight Blue",
        "brand": "Black Rhino Hard Alloys",
        "size": "18x9.0 12",
        "price": 128.0,
        "cap_part_no": "CCBR66135140MM"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-br-cap-anim-bolt-on-(mb-mb-mb)-6x135-5.5-ccbr66135140mm",
        "title": "Br Cap Anim Bolt-On (Mb/Mb/Mb)-6X135/5.5",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa40-vertigo-17x9--6-satin-black-milled-pxa5140-7983",
        "title": "Pro Comp Alloys Pa40 Vertigo 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 167.0,
        "cap_part_no": "PXA504055602"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "pro-comp-alloys-pxa-snap-in-cap-s-blk-pxa504055602",
        "title": "Pxa Snap-In Cap S-Blk",
        "price": 26.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906801",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 435.0,
        "cap_part_no": "1004-27BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x5.5-1004-27bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X5.5",
        "price": 34.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208583+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-tacoma-gen-4-2024-2025": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-rapid-18x9-+12-midnight-blue-1890rpd126140u12",
        "title": "Black Rhino Hard Alloys Rapid 18X9 +12 Midnight Blue",
        "brand": "Black Rhino Hard Alloys",
        "size": "18x9.0 12",
        "price": 128.0,
        "cap_part_no": "CCBR66135140MM"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-br-cap-anim-bolt-on-(mb-mb-mb)-6x135-5.5-ccbr66135140mm",
        "title": "Br Cap Anim Bolt-On (Mb/Mb/Mb)-6X135/5.5",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa40-vertigo-17x9--6-satin-black-milled-pxa5140-7983",
        "title": "Pro Comp Alloys Pa40 Vertigo 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 167.0,
        "cap_part_no": "PXA504055602"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "pro-comp-alloys-pxa-snap-in-cap-s-blk-pxa504055602",
        "title": "Pxa Snap-In Cap S-Blk",
        "price": 26.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906801",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 435.0,
        "cap_part_no": "1004-27BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x5.5-1004-27bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X5.5",
        "price": 34.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208583+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-4runner-gen-4-2003-2009": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-rapid-18x9-+12-midnight-blue-1890rpd126140u12",
        "title": "Black Rhino Hard Alloys Rapid 18X9 +12 Midnight Blue",
        "brand": "Black Rhino Hard Alloys",
        "size": "18x9.0 12",
        "price": 128.0,
        "cap_part_no": "CCBR66135140MM"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-br-cap-anim-bolt-on-(mb-mb-mb)-6x135-5.5-ccbr66135140mm",
        "title": "Br Cap Anim Bolt-On (Mb/Mb/Mb)-6X135/5.5",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa40-vertigo-17x9--6-satin-black-milled-pxa5140-7983",
        "title": "Pro Comp Alloys Pa40 Vertigo 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 167.0,
        "cap_part_no": "PXA504055602"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "pro-comp-alloys-pxa-snap-in-cap-s-blk-pxa504055602",
        "title": "Pxa Snap-In Cap S-Blk",
        "price": 26.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906801",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 435.0,
        "cap_part_no": "1004-27BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x5.5-1004-27bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X5.5",
        "price": 34.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208583+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-4runner-gen-5-2010-2025": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-rapid-18x9-+12-midnight-blue-1890rpd126140u12",
        "title": "Black Rhino Hard Alloys Rapid 18X9 +12 Midnight Blue",
        "brand": "Black Rhino Hard Alloys",
        "size": "18x9.0 12",
        "price": 128.0,
        "cap_part_no": "CCBR66135140MM"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-br-cap-anim-bolt-on-(mb-mb-mb)-6x135-5.5-ccbr66135140mm",
        "title": "Br Cap Anim Bolt-On (Mb/Mb/Mb)-6X135/5.5",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa40-vertigo-17x9--6-satin-black-milled-pxa5140-7983",
        "title": "Pro Comp Alloys Pa40 Vertigo 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 167.0,
        "cap_part_no": "PXA504055602"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "pro-comp-alloys-pxa-snap-in-cap-s-blk-pxa504055602",
        "title": "Pxa Snap-In Cap S-Blk",
        "price": 26.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906801",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 435.0,
        "cap_part_no": "1004-27BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x5.5-1004-27bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X5.5",
        "price": 34.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208583+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-fj-cruiser-2007-2014": {
    "Daily+": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-rapid-18x9-+12-midnight-blue-1890rpd126140u12",
        "title": "Black Rhino Hard Alloys Rapid 18X9 +12 Midnight Blue",
        "brand": "Black Rhino Hard Alloys",
        "size": "18x9.0 12",
        "price": 128.0,
        "cap_part_no": "CCBR66135140MM"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-225-45r18-f28963824",
        "title": "Falken Ziex Ze960 A/S 225/45R18",
        "size": "225/45R18",
        "price": 164.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-br-cap-anim-bolt-on-(mb-mb-mb)-6x135-5.5-ccbr66135140mm",
        "title": "Br Cap Anim Bolt-On (Mb/Mb/Mb)-6X135/5.5",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa40-vertigo-17x9--6-satin-black-milled-pxa5140-7983",
        "title": "Pro Comp Alloys Pa40 Vertigo 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 167.0,
        "cap_part_no": "PXA504055602"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "pro-comp-alloys-pxa-snap-in-cap-s-blk-pxa504055602",
        "title": "Pxa Snap-In Cap S-Blk",
        "price": 26.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20906801",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 435.0,
        "cap_part_no": "1004-27BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---6x5.5-1004-27bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 6X5.5",
        "price": 34.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s109-push-20x8.5-+35-gloss-black-milled-s109208583+35",
        "title": "Dub 1Pc S109 Push 20X8.5 +35 Gloss Black Milled",
        "brand": "Dub 1Pc",
        "size": "20x8.5 35",
        "price": 225.0,
        "cap_part_no": "16390-15BME"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "dub-1pc-dub-push-cap-black-milled-edge-16390-15bme",
        "title": "Dub Push Cap-Black/Milled Edge",
        "price": 39.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "fuel-1pc-d121-unit-beadlock-17x9--15-candy-red-d12117908445",
        "title": "Fuel 1Pc D121 Unit Beadlock 17X9 -15 Candy Red",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -15",
        "price": 313.0,
        "cap_part_no": "1006-12MBQ"
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 24
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-6x5.5-large-bore-mb-red-logo-1006-12mbq",
        "title": "Fuel Cap 6X5.5 Large Bore Mb/Red Logo",
        "price": 23.0,
        "qty": 4
      }
    }
  },
  "toyota-land-cruiser-gen-4-2008-2021": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd820-grenade-20x9-+0-satin-black-milled-xd82029058900us",
        "title": "Xd Xd820 Grenade 20X9 +0 Satin Black Milled",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 308.0,
        "cap_part_no": "1079L145ASB-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-5x5.5-150---satin-black-1079l145asb-h42",
        "title": "Xds Cap 5X5.5/150 - Satin Black",
        "price": 26.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d749-hammer-20x10--18-gloss-black-milled-d74920005647",
        "title": "Fuel 1Pc D749 Hammer 20X10 -18 Gloss Black Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 457.0,
        "cap_part_no": "1006-15GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-5x150-gb-chr-logo-1006-15gb",
        "title": "Fuel Cap 5X150 Gb Chr Logo",
        "price": 27.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-ff110-22x10--25-polished-ffgff110rt10-1-34",
        "title": "Fuel 1Pc Ff110 22X10 -25 Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -25",
        "price": 720.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d864-hurricane-22x12--44-blackout-d86422205647",
        "title": "Fuel 1Pc D864 Hurricane 22X12 -44 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x12.0 -44",
        "price": 560.0,
        "cap_part_no": "1004-42BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x150-1004-42bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X150",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278558500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "toyota-land-cruiser-gen-5-2022-2025": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd820-grenade-20x9-+0-satin-black-milled-xd82029058900us",
        "title": "Xd Xd820 Grenade 20X9 +0 Satin Black Milled",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 308.0,
        "cap_part_no": "1079L145ASB-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-5x5.5-150---satin-black-1079l145asb-h42",
        "title": "Xds Cap 5X5.5/150 - Satin Black",
        "price": 26.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d749-hammer-20x10--18-gloss-black-milled-d74920005647",
        "title": "Fuel 1Pc D749 Hammer 20X10 -18 Gloss Black Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 457.0,
        "cap_part_no": "1006-15GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-5x150-gb-chr-logo-1006-15gb",
        "title": "Fuel Cap 5X150 Gb Chr Logo",
        "price": 27.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-ff110-22x10--25-polished-ffgff110rt10-1-34",
        "title": "Fuel 1Pc Ff110 22X10 -25 Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -25",
        "price": 720.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d864-hurricane-22x12--44-blackout-d86422205647",
        "title": "Fuel 1Pc D864 Hurricane 22X12 -44 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x12.0 -44",
        "price": 560.0,
        "cap_part_no": "1004-42BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x150-1004-42bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X150",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278558500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "toyota-sequoia-gen-2-2008-2022": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd820-grenade-20x9-+0-satin-black-milled-xd82029058900us",
        "title": "Xd Xd820 Grenade 20X9 +0 Satin Black Milled",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 308.0,
        "cap_part_no": "1079L145ASB-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-5x5.5-150---satin-black-1079l145asb-h42",
        "title": "Xds Cap 5X5.5/150 - Satin Black",
        "price": 26.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d749-hammer-20x10--18-gloss-black-milled-d74920005647",
        "title": "Fuel 1Pc D749 Hammer 20X10 -18 Gloss Black Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 457.0,
        "cap_part_no": "1006-15GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-5x150-gb-chr-logo-1006-15gb",
        "title": "Fuel Cap 5X150 Gb Chr Logo",
        "price": 27.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-ff110-22x10--25-polished-ffgff110rt10-1-34",
        "title": "Fuel 1Pc Ff110 22X10 -25 Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -25",
        "price": 720.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d864-hurricane-22x12--44-blackout-d86422205647",
        "title": "Fuel 1Pc D864 Hurricane 22X12 -44 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x12.0 -44",
        "price": 560.0,
        "cap_part_no": "1004-42BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x150-1004-42bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X150",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278558500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "toyota-sequoia-gen-3-2023-2025": {
    "Daily+": {
      "wheel": {
        "handle": "xd-xd820-grenade-20x9-+0-satin-black-milled-xd82029058900us",
        "title": "Xd Xd820 Grenade 20X9 +0 Satin Black Milled",
        "brand": "Xd",
        "size": "20x9.0 0",
        "price": 308.0,
        "cap_part_no": "1079L145ASB-H42"
      },
      "tire": {
        "handle": "falken-ziex-ze960-a-s-245-35r20-f28963985",
        "title": "Falken Ziex Ze960 A/S 245/35R20",
        "size": "245/35R20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "xd-xds-cap-5x5.5-150---satin-black-1079l145asb-h42",
        "title": "Xds Cap 5X5.5/150 - Satin Black",
        "price": 26.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d749-hammer-20x10--18-gloss-black-milled-d74920005647",
        "title": "Fuel 1Pc D749 Hammer 20X10 -18 Gloss Black Milled",
        "brand": "Fuel 1Pc",
        "size": "20x10.0 -18",
        "price": 457.0,
        "cap_part_no": "1006-15GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-cap-5x150-gb-chr-logo-1006-15gb",
        "title": "Fuel Cap 5X150 Gb Chr Logo",
        "price": 27.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-ff110-22x10--25-polished-ffgff110rt10-1-34",
        "title": "Fuel 1Pc Ff110 22X10 -25 Polished",
        "brand": "Fuel 1Pc",
        "size": "22x10.0 -25",
        "price": 720.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-azenis-fk510-295-25zr22-f28032077",
        "title": "Falken Azenis Fk510 295/25ZR22",
        "size": "295/25ZR22",
        "price": 347.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d864-hurricane-22x12--44-blackout-d86422205647",
        "title": "Fuel 1Pc D864 Hurricane 22X12 -44 Blackout",
        "brand": "Fuel 1Pc",
        "size": "22x12.0 -44",
        "price": 560.0,
        "cap_part_no": "1004-42BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x150-1004-42bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X150",
        "price": 37.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278558500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "jeep-wrangler-tj-1997-2006": {
    "Daily+": {
      "wheel": {
        "handle": "american-racing-vintage-vn504-17x9-+12-polished-vn50479012112",
        "title": "American Racing Vintage Vn504 17X9 +12 Polished",
        "brand": "American Racing Vintage",
        "size": "17x9.0 12",
        "price": 193.0,
        "cap_part_no": "VN504CAPB-POL"
      },
      "tire": {
        "handle": "falken-wildpeak-h-t01a2-215-65r17-f59000032",
        "title": "Falken Wildpeak H/T01A2 215/65R17",
        "size": "215/65R17",
        "price": 148.61
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "american-racing-vintage-vn504-cap-snap-in-polished-vn504capb-pol",
        "title": "Vn504 Cap Snap In Polished",
        "price": 51.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d611-stroke-17x9--12-gloss-black-milled-d61117902645",
        "title": "Fuel 1Pc D611 Stroke 17X9 -12 Gloss Black Milled",
        "brand": "Fuel 1Pc",
        "size": "17x9.0 -12",
        "price": 217.0,
        "cap_part_no": "1003-84GBR"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fuel-eight-bar-cover-cap-gl-blk-blk-riv-1003-84gbr",
        "title": "Fuel Eight Bar Cover Cap-Gl-Blk/Blk Riv",
        "price": 27.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "asanti-forged-af143-20x8.5-+-chrome-&-black-af143208565+40",
        "title": "Asanti Forged Af143 20X8.5 + Chrome & Black",
        "brand": "Asanti Forged",
        "size": "20x8.5 0",
        "price": 604.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "dub-1pc-s261-g.o.a.t.-20x9-+35-silver-brushed-face-s261209065+35",
        "title": "Dub 1Pc S261 G.O.A.T. 20X9 +35 Silver Brushed Face",
        "brand": "Dub 1Pc",
        "size": "20x9.0 35",
        "price": 226.0,
        "cap_part_no": "1003-05-04M"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "dub-1pc-dub-machine-brush-3.0\"-flat-cap-1003-05-04m",
        "title": "Dub Machine/Brush 3.0\" Flat Cap",
        "price": 24.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278512500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "gorilla-automotive-acorn-oe-lug-3-4\"-12-1.50-zinc-bulk-70038s",
        "title": "Acorn Oe Lug 3/4\" 12-1.50 Zinc Bulk",
        "price": 0.8,
        "thread_pitch": "M12x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "jeep-wrangler-jl-2018-2025": {
    "Daily+": {
      "wheel": {
        "handle": "pro-comp-alloys-pa035-predator-17x8.5-+0-dark-gray-w--black-lip-pxa2635-78573",
        "title": "Pro Comp Alloys Pa035 Predator 17X8.5 +0 Dark Gray W/ Black Lip",
        "brand": "Pro Comp Alloys",
        "size": "17x8.5 0",
        "price": 120.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-wildpeak-h-t01a2-215-65r17-f59000032",
        "title": "Falken Wildpeak H/T01A2 215/65R17",
        "size": "215/65R17",
        "price": 148.61
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa64-gunner-17x9--6-satin-black-milled-pxa5164-7973",
        "title": "Pro Comp Alloys Pa64 Gunner 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 157.0,
        "cap_part_no": "PXA516455002"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20905001",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 230.0,
        "cap_part_no": "1004-44BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x4.5-5-1004-44bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X4.5/5",
        "price": 33.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-morocco-20x9-+30-gloss-black-2090mrc305127b71",
        "title": "Black Rhino Hard Alloys Morocco 20X9 +30 Gloss Black",
        "brand": "Black Rhino Hard Alloys",
        "size": "20x9.0 30",
        "price": 291.0,
        "cap_part_no": "CCBRPSC002GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-cap-br-pop-in-gl-blk-w-blk-letrs-ccbrpsc002gb",
        "title": "Cap Br Pop In Gl Blk W/Blk Letrs",
        "price": 9.5,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278550500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "jeep-gladiator-jt-2020-2025": {
    "Daily+": {
      "wheel": {
        "handle": "pro-comp-alloys-pa035-predator-17x8.5-+0-dark-gray-w--black-lip-pxa2635-78573",
        "title": "Pro Comp Alloys Pa035 Predator 17X8.5 +0 Dark Gray W/ Black Lip",
        "brand": "Pro Comp Alloys",
        "size": "17x8.5 0",
        "price": 120.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "falken-wildpeak-h-t01a2-215-65r17-f59000032",
        "title": "Falken Wildpeak H/T01A2 215/65R17",
        "size": "215/65R17",
        "price": 148.61
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "pro-comp-alloys-pa64-gunner-17x9--6-satin-black-milled-pxa5164-7973",
        "title": "Pro Comp Alloys Pa64 Gunner 17X9 -6 Satin Black Milled",
        "brand": "Pro Comp Alloys",
        "size": "17x9.0 -6",
        "price": 157.0,
        "cap_part_no": "PXA516455002"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-245-65r17-m24552518",
        "title": "Milestar Patagonia A/T R 245/65R17",
        "size": "245/65R17",
        "price": 145.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    },
    "Street & Show": {
      "wheel": {
        "handle": "fuel-1pc-fc862-scepter-20x9-+1-blackout-fc862mx20905001",
        "title": "Fuel 1Pc Fc862 Scepter 20X9 +1 Blackout",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 230.0,
        "cap_part_no": "1004-44BLD"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(mb-gb)---5x4.5-5-1004-44bld",
        "title": "Fc Cap Bolt-On (Mb/Gb) - 5X4.5/5",
        "price": 33.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "black-rhino-hard-alloys-morocco-20x9-+30-gloss-black-2090mrc305127b71",
        "title": "Black Rhino Hard Alloys Morocco 20X9 +30 Gloss Black",
        "brand": "Black Rhino Hard Alloys",
        "size": "20x9.0 30",
        "price": 291.0,
        "cap_part_no": "CCBRPSC002GB"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-225-35zr20-m24000034",
        "title": "Milestar Interceptor As810 225/35ZR20",
        "size": "225/35ZR20",
        "price": 110.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "black-rhino-hard-alloys-cap-br-pop-in-gl-blk-w-blk-letrs-ccbrpsc002gb",
        "title": "Cap Br Pop In Gl Blk W/Blk Letrs",
        "price": 9.5,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278550500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "jeep-grand-cherokee-wk2-2011-2021": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d564-beast-20x9-+35-matte-black-double-dark-tint-d56420907563",
        "title": "Fuel 1Pc D564 Beast 20X9 +35 Matte Black Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 35",
        "price": 285.0,
        "cap_part_no": "1003-47MB"
      },
      "tire": {
        "handle": "nitto-motivo-255-35zr20-n210-430",
        "title": "Nitto Motivo 255/35ZR20",
        "size": "255/35ZR20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-snap-in-(mb-ch)-od-80.6-id-79.4-1003-47mb",
        "title": "Fc Cap Snap-In (Mb/Ch) Od 80.6 Id 79.4",
        "price": 13.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d708-rogue-20x9-+1-gloss-mach-double-dark-tint-d70820907550",
        "title": "Fuel 1Pc D708 Rogue 20X9 +1 Gloss Mach Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 244.0,
        "cap_part_no": "1004-44GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(gb-ch)---5x4.5-5-1004-44gb",
        "title": "Fc Cap Bolt-On (Gb/Ch) - 5X4.5/5",
        "price": 33.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "dub-1pc-s258-g.o.a.t.-22x9-+35-chrome-s258229075+35",
        "title": "Dub 1Pc S258 G.O.A.T. 22X9 +35 Chrome",
        "brand": "Dub 1Pc",
        "size": "22x9.0 35",
        "price": 604.0,
        "cap_part_no": "1003-07-04"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "dub-1pc-dub-lens-clad-3.0\"-o-ring-cap-1003-07-04",
        "title": "Dub Lens Clad 3.0\" O-Ring Cap",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr161-22x9.5-+35-copper-161co-22957335",
        "title": "Performance Replicas Pr161 22X9.5 +35 Copper",
        "brand": "Performance Replicas",
        "size": "22x9.5 35",
        "price": 427.0,
        "cap_part_no": "161CO"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "performance-replicas-pr161-replacement-cap---copper-161co",
        "title": "Pr161 Replacement Cap - Copper",
        "price": 20.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278550500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "jeep-grand-cherokee-wl-2022-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d564-beast-20x9-+35-matte-black-double-dark-tint-d56420907563",
        "title": "Fuel 1Pc D564 Beast 20X9 +35 Matte Black Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 35",
        "price": 285.0,
        "cap_part_no": "1003-47MB"
      },
      "tire": {
        "handle": "nitto-motivo-255-35zr20-n210-430",
        "title": "Nitto Motivo 255/35ZR20",
        "size": "255/35ZR20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-snap-in-(mb-ch)-od-80.6-id-79.4-1003-47mb",
        "title": "Fc Cap Snap-In (Mb/Ch) Od 80.6 Id 79.4",
        "price": 13.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d708-rogue-20x9-+1-gloss-mach-double-dark-tint-d70820907550",
        "title": "Fuel 1Pc D708 Rogue 20X9 +1 Gloss Mach Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 244.0,
        "cap_part_no": "1004-44GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(gb-ch)---5x4.5-5-1004-44gb",
        "title": "Fc Cap Bolt-On (Gb/Ch) - 5X4.5/5",
        "price": 33.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "dub-1pc-s258-g.o.a.t.-22x9-+35-chrome-s258229075+35",
        "title": "Dub 1Pc S258 G.O.A.T. 22X9 +35 Chrome",
        "brand": "Dub 1Pc",
        "size": "22x9.0 35",
        "price": 604.0,
        "cap_part_no": "1003-07-04"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "dub-1pc-dub-lens-clad-3.0\"-o-ring-cap-1003-07-04",
        "title": "Dub Lens Clad 3.0\" O-Ring Cap",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr161-22x9.5-+35-copper-161co-22957335",
        "title": "Performance Replicas Pr161 22X9.5 +35 Copper",
        "brand": "Performance Replicas",
        "size": "22x9.5 35",
        "price": 427.0,
        "cap_part_no": "161CO"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "performance-replicas-pr161-replacement-cap---copper-161co",
        "title": "Pr161 Replacement Cap - Copper",
        "price": 20.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278550500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  },
  "jeep-wagoneer-2022-2025": {
    "Daily+": {
      "wheel": {
        "handle": "fuel-1pc-d564-beast-20x9-+35-matte-black-double-dark-tint-d56420907563",
        "title": "Fuel 1Pc D564 Beast 20X9 +35 Matte Black Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 35",
        "price": 285.0,
        "cap_part_no": "1003-47MB"
      },
      "tire": {
        "handle": "nitto-motivo-255-35zr20-n210-430",
        "title": "Nitto Motivo 255/35ZR20",
        "size": "255/35ZR20",
        "price": 161.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-snap-in-(mb-ch)-od-80.6-id-79.4-1003-47mb",
        "title": "Fc Cap Snap-In (Mb/Ch) Od 80.6 Id 79.4",
        "price": 13.0,
        "qty": 4
      }
    },
    "Lifted Trucks": {
      "wheel": {
        "handle": "fuel-1pc-d708-rogue-20x9-+1-gloss-mach-double-dark-tint-d70820907550",
        "title": "Fuel 1Pc D708 Rogue 20X9 +1 Gloss Mach Double Dark Tint",
        "brand": "Fuel 1Pc",
        "size": "20x9.0 1",
        "price": 244.0,
        "cap_part_no": "1004-44GB"
      },
      "tire": {
        "handle": "milestar-patagonia-a-t-r-275-55r20-m22520005",
        "title": "Milestar Patagonia A/T R 275/55R20",
        "size": "275/55R20",
        "price": 187.95
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "fuel-1pc-fc-cap-bolt-on-(gb-ch)---5x4.5-5-1004-44gb",
        "title": "Fc Cap Bolt-On (Gb/Ch) - 5X4.5/5",
        "price": 33.0,
        "qty": 4
      }
    },
    "Street & Show": {
      "wheel": {
        "handle": "dub-1pc-s258-g.o.a.t.-22x9-+35-chrome-s258229075+35",
        "title": "Dub 1Pc S258 G.O.A.T. 22X9 +35 Chrome",
        "brand": "Dub 1Pc",
        "size": "22x9.0 35",
        "price": 604.0,
        "cap_part_no": "1003-07-04"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "dub-1pc-dub-lens-clad-3.0\"-o-ring-cap-1003-07-04",
        "title": "Dub Lens Clad 3.0\" O-Ring Cap",
        "price": 17.0,
        "qty": 4
      }
    },
    "Lowered Trucks": {
      "wheel": {
        "handle": "performance-replicas-pr161-22x9.5-+35-copper-161co-22957335",
        "title": "Performance Replicas Pr161 22X9.5 +35 Copper",
        "brand": "Performance Replicas",
        "size": "22x9.5 35",
        "price": 427.0,
        "cap_part_no": "161CO"
      },
      "tire": {
        "handle": "milestar-interceptor-as810-265-35zr22-m24072006",
        "title": "Milestar Interceptor As810 265/35ZR22",
        "size": "265/35ZR22",
        "price": 160.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": {
        "handle": "performance-replicas-pr161-replacement-cap---copper-161co",
        "title": "Pr161 Replacement Cap - Copper",
        "price": 20.0,
        "qty": 4
      }
    },
    "Offroad Performance": {
      "wheel": {
        "handle": "xd-xd222-enduro-beadlock-17x8.5-+0-machined-xd22278550500",
        "title": "Xd Xd222 Enduro Beadlock 17X8.5 +0 Machined",
        "brand": "Xd",
        "size": "17x8.5 0",
        "price": 310.0,
        "cap_part_no": null
      },
      "tire": {
        "handle": "mickey-thompson-tire-baja-legend-mtz-315-70r17-mtt272498",
        "title": "Mickey Thompson Tire Baja Legend Mtz 315/70R17",
        "size": "315/70R17",
        "price": 338.0
      },
      "lug_nut": {
        "handle": "american-racing-14mm-1.5-6point-conical-lug-30mm-851154x",
        "title": "14Mm-1.5 6Point Conical Lug 30Mm",
        "price": 1.9,
        "thread_pitch": "M14x1.5",
        "qty": 20
      },
      "center_cap": null
    }
  }
};

if (typeof module !== "undefined") module.exports = LF_BUNDLES;
